import styles from "./wave-background.module.css";

// Ported directly from packages/ui/src/components/backgrounds/wave.tsx (the
// real WaveBackground used on error pages elsewhere in this monorepo) — the
// SVG's own <animate>/<animateTransform> attribute animations are
// self-contained and framework-agnostic, so this is a straight port with
// only the OUTER positioning classes swapped from Tailwind to CSS Modules.
export function WaveBackground() {
  return (
    <div className={styles.wave} aria-hidden="true">
      <svg
        className={styles.svg}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1200 320"
        preserveAspectRatio="none"
      >
        <defs>
          <linearGradient id="wave1" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#e9366b" stopOpacity="0.15" />
            <stop offset="100%" stopColor="#ee712a" stopOpacity="0.15" />
          </linearGradient>
          <linearGradient id="wave2" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#ee712a" stopOpacity="0.1" />
            <stop offset="100%" stopColor="#e9366b" stopOpacity="0.1" />
          </linearGradient>
        </defs>

        <path
          d="M0,96L48,112C96,128,192,160,288,160C384,160,480,128,576,133.3C672,139,768,181,864,181.3C960,181,1056,139,1152,128C1248,117,1344,139,1392,149.3L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
          fill="url(#wave1)"
        >
          <animate
            attributeName="d"
            values="M0,96L48,112C96,128,192,160,288,160C384,160,480,128,576,133.3C672,139,768,181,864,181.3C960,181,1056,139,1152,128C1248,117,1344,139,1392,149.3L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z;
                   M0,116L48,102C96,118,192,140,288,145C384,150,480,138,576,123.3C672,109,768,171,864,175.3C960,179,1056,129,1152,148C1248,167,1344,119,1392,145.3L1440,140L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z;
                   M0,86L48,122C96,108,192,180,288,175C384,170,480,118,576,143.3C672,169,768,191,864,187.3C960,183,1056,149,1152,108C1248,87,1344,159,1392,153.3L1440,180L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z;
                   M0,96L48,112C96,128,192,160,288,160C384,160,480,128,576,133.3C672,139,768,181,864,181.3C960,181,1056,139,1152,128C1248,117,1344,139,1392,149.3L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
            dur="10s"
            repeatCount="indefinite"
          />
          <animateTransform
            attributeName="transform"
            attributeType="XML"
            values="translate(-1440 0);translate(0 0);translate(1440 0)"
            dur="18s"
            repeatCount="indefinite"
          />
        </path>

        <path
          d="M0,224L48,213.3C96,203,192,181,288,181.3C384,181,480,203,576,208C672,213,768,203,864,192C960,181,1056,171,1152,165.3C1248,160,1344,160,1392,160L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
          fill="url(#wave2)"
        >
          <animate
            attributeName="d"
            values="M0,224L48,213.3C96,203,192,181,288,181.3C384,181,480,203,576,208C672,213,768,203,864,192C960,181,1056,171,1152,165.3C1248,160,1344,160,1392,160L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z;
                   M0,244L48,233.3C96,223,192,201,288,201.3C384,201,480,223,576,228C672,233,768,223,864,212C960,201,1056,191,1152,185.3C1248,180,1344,180,1392,180L1440,180L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z;
                   M0,204L48,193.3C96,183,192,161,288,161.3C384,161,480,183,576,188C672,193,768,183,864,172C960,161,1056,151,1152,145.3C1248,140,1344,140,1392,140L1440,140L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z;
                   M0,234L48,203.3C96,213,192,191,288,195.3C384,199,480,213,576,218C672,223,768,193,864,182C960,171,1056,181,1152,175.3C1248,170,1344,170,1392,170L1440,150L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z;
                   M0,224L48,213.3C96,203,192,181,288,181.3C384,181,480,203,576,208C672,213,768,203,864,192C960,181,1056,171,1152,165.3C1248,160,1344,160,1392,160L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
            dur="14s"
            repeatCount="indefinite"
          />
          <animateTransform
            attributeName="transform"
            attributeType="XML"
            values="translate(1440 0);translate(0 0);translate(-1440 0)"
            dur="22s"
            repeatCount="indefinite"
          />
        </path>
      </svg>
    </div>
  );
}
